export const VERSION="2.2.1"



// WEBPACK FOOTER //
// ./src/version.js